import { Identifier } from "../../core";
export class PromotionInstanceId extends Identifier {
    constructor(id) {
        super("PromotionInstanceId", id);
    }
}
